import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { downloadSystemEventsFailed, downloadSystemEventsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* downloadSystemEvents(action) {
  try {
    const ids = action.payload;
    const url = `${BACKEND_URL}/api/v1/system-logs/download`;
    const dataResponse = yield makeRequest(url, { ids }, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(downloadSystemEventsSuccessful());
      const timestamp = dataResponse.headers.get('X-Snapshot-Timestamp') || '';
      yield call(resolveActionPromise(action, { data, timestamp }));
    } else {
      yield put(downloadSystemEventsFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(downloadSystemEventsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
